import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Redirect } from "react-router";
import { Container, Jumbotron, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import Loader from "../components/common/Loader";
import TenantListComponent from "../components/TenantListComponent";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";

const OfflineTenantSelectionLayout = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadTenantsFromDb, tenantArray, loadUserFromDb, directTenantAccess, setDirectTenantAccess } = rootStore.offlineStore;
  const [t] = useTranslation(["nativeapp"], translationHookOptions);

  useEffect(() => {
    clearAllBodyScrollLocks();
    document.body.classList.remove("p-0");
    document.body.classList.add("form-membership");
  }, []);

  useEffect(() => {
    if (!tenantArray) {
      loadUserFromDb().then(() => loadTenantsFromDb());
    }
    return () => {
      setDirectTenantAccess(null);
    };
  }, [loadUserFromDb, loadTenantsFromDb, tenantArray, setDirectTenantAccess]);

  if (!tenantArray) return <Loader />;

  if (tenantArray.length === 1)
    return <Redirect to={`${tenantArray[0].path}/meetings`} />;
  

  if (directTenantAccess)
    return <Redirect to={`/${directTenantAccess}/meetings`} />;

  return (
    <Container>
      <Jumbotron className="form-wrapper w-100  mt-0">
        <h3 className="text-center font-weight-bold">{t("select_offline_portal")}</h3>
        <hr />
        <Row className="justify-content-center">
          {tenantArray && <TenantListComponent tenants={tenantArray} />}
        </Row>
      </Jumbotron>
    </Container>
    
  );
};

export default observer(OfflineTenantSelectionLayout);
